module.exports = __webpack_public_path__ + "img/selected5-min.e05de69a.png";